"use client";

import { HashRouter as Router } from "react-router";
import { Authenticated, Unauthenticated } from "convex/react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { ThemeProvider } from "./components/ThemeProvider";
import AuthenticatedApp from "./components/AuthenticatedApp";
import UnauthenticatedApp from "./components/UnauthenticatedApp";
import "./lib/i18n";

export default function App() {
  // Google Maps API key from environment variables
  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";

  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <ThemeProvider defaultTheme="system" storageKey="gpsbox-ui-theme">
        <div className="min-h-screen bg-background text-foreground">
          <Router>
            <Authenticated>
              <AuthenticatedApp />
            </Authenticated>
            <Unauthenticated>
              <UnauthenticatedApp />
            </Unauthenticated>
          </Router>
        </div>
      </ThemeProvider>
    </APIProvider>
  );
}
